module.exports = __webpack_public_path__ + "img/gourmetrde.1d71563e.jpg";